import { ICurrencyLabel } from "@/interfaces/ICurrencyLabel";
import {
  exchangeRateSymbolPrecisions,
  symbolPrecisions,
} from "@/utils/numberUtils";
import BigNumber from "bignumber.js";

export const CurrencyBody = (props: ICurrencyLabel) => {
  return (
    <>
      {props.ignoreSymbolPrecision
        ? BigNumber(props.children).toFormat()
        : BigNumber(props.children).toFormat(
            props.precision === undefined
              ? props.isExchangeRate
                ? exchangeRateSymbolPrecisions(props.symbol)
                : symbolPrecisions(props.symbol)
              : props.precision,
            BigNumber.ROUND_HALF_UP,
          )}
      {props.showSymbol ? ` ${props.symbol}` : ""}
    </>
  );
};
